import React, { ReactElement, SVGProps } from 'react';

export const SvgFacebook = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg fill="none" height={45} width={45} {...props}>
      <circle fill="#25C5B0" r={22.5} cy={22.5} cx={22.5} />
      <path
        d="M22.962 13.27c-4.962 0-9 4.038-9 9 0 4.961 4.038 9 9 9s9-4.039 9-9c0-4.962-4.038-9-9-9zm0 1.5c4.151 0 7.5 3.348 7.5 7.5a7.482 7.482 0 01-6.384 7.409v-5.223h2.136l.335-2.17h-2.47v-1.184c0-.9.295-1.7 1.137-1.7h1.354v-1.893c-.238-.033-.741-.103-1.692-.103-1.986 0-3.15 1.049-3.15 3.438v1.443h-2.041v2.17h2.042v5.202a7.481 7.481 0 01-6.267-7.39c0-4.15 3.349-7.5 7.5-7.5z"
        fill="#fff"
      />
    </svg>
  );
};
